import React from 'react'

class WaveHeight extends React.Component {

  render() {
    let waveHeight;
    if (this.props.data.value !== null && this.props.data.age < this.props.maxAge) {
      waveHeight = <div className="height">{this.props.data.value} cm</div>;
    } else {
      waveHeight = <div className="height nodata">-</div>
    }
    
    return (
      <div>
        {waveHeight}
      </div>
    );
  }

}

export default WaveHeight;



// WEBPACK FOOTER //
// ./src/Components/WaveHeight.jsx